import { render, staticRenderFns } from "./Diagnostics.vue?vue&type=template&id=2f05a386"
import script from "./Diagnostics.vue?vue&type=script&lang=ts"
export * from "./Diagnostics.vue?vue&type=script&lang=ts"
import style0 from "./Diagnostics.vue?vue&type=style&index=0&id=2f05a386&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports